import { Component, OnInit, inject } from '@angular/core';
import { THEME, ThemeService } from '../../../services/theme.service';
import { NgClass } from '@angular/common';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';

@Component({
    selector: 'app-theme-selector',
    templateUrl: './theme-selector.component.html',
    styleUrls: ['./theme-selector.component.scss'],
    imports: [ClickOutsideDirective, NgClass]
})
export class ThemeSelectorComponent implements OnInit {
  theme = inject(ThemeService);


  /**
   * Property for toggle dropdown
   */
  open: boolean;

  /**
   * Gradients for dropdown options
   */
  gradients = {
    [THEME.DEFAULT_DARK]: 'linear-gradient(237.12deg, #FFCEA8 0%, #C3A6FC 50.52%, #80FEF7 100%)',
    [THEME.HOLLAND]: 'linear-gradient(222.83deg, #FFDD66 3.51%, #FA9B66 50.25%, #FA9B66 57.28%, #FF7C33 100%)',
    [THEME.AU]: 'linear-gradient(225.18deg, #B0FFB7 5.2%, #4FE7B7 49.48%, #02BFC1 95.65%)',
    [THEME.DE_CA]: 'linear-gradient(133.83deg, #FF0000 12.44%, #FFFFFF 80.53%)',
    [THEME.BR_MX_ZAF]: 'linear-gradient(225deg, #DCF929 0%, #88E73D 52.6%, #4DDD4A 100%)',
    [THEME.INDIA]: 'linear-gradient(135deg, #9B15FF 0%, #FA8597 52.08%, #FEF392 100%)',
    [THEME.INDONESIA]: 'linear-gradient(225deg, #FFDC97 0%, #FF9A84 52.08%, #FA88A4 100%)',
    [THEME.VIP]: 'linear-gradient(133.83deg, #DD6F31 12.44%, #FFC42B 80.53%)',
  };

  /**
   * Background for dropdown options
   */
  backgrounds = {
    light: '#fff'
  };

  selectors = [
    {
      darkTheme: THEME.DEFAULT_DARK,
      gradient: this.gradients[THEME.DEFAULT_DARK],
    },
    {
      darkTheme: THEME.HOLLAND,
      gradient: this.gradients[THEME.HOLLAND],
    },
    {
      darkTheme: THEME.AU,
      gradient: this.gradients[THEME.AU],
    },
    {
      darkTheme: THEME.DE_CA,
      gradient: this.gradients[THEME.DE_CA],
    },
    {
      darkTheme: THEME.BR_MX_ZAF,
      gradient: this.gradients[THEME.BR_MX_ZAF],
    },
    {
      darkTheme: THEME.INDIA,
      gradient: this.gradients[THEME.INDIA],
    },
    {
      darkTheme: THEME.INDONESIA,
      gradient: this.gradients[THEME.INDONESIA],
    },
  ];

  ngOnInit(): void {
  }

  setTheme(theme: THEME) {
    this.theme.setTheme(theme);
    this.open = false;
  }
}
